"use client";

import Script from "next/script";

type AnalyticsProps = {
  googleAnalyticsId?: string;
  gtmId?: string;
};

export default function Analytics({ googleAnalyticsId, gtmId }: AnalyticsProps) {
  let skipScripts = false;
  if (global.window) {
    if (window.gaTagLoaded == 1) {
      skipScripts = true;
    } else {
      window.gaTagLoaded = 1;
    }
  }

  return skipScripts ? null : (
    <>
      {googleAnalyticsId && (
        <>
          <Script
            strategy="lazyOnload"
            src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
          />
          <Script strategy="afterInteractive">
            {`
            window.ga4Enabled = true;
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${googleAnalyticsId}');
        `}
          </Script>
        </>
      )}
      {gtmId && (
        <Script strategy="afterInteractive">
          {`
          window.gtmEnabled = true;
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `}
        </Script>
      )}
    </>
  );
}
